import React, { PureComponent } from 'react';
import { observer, inject } from 'mobx-react';
import _ from 'lodash';
import HttpClient from 'services/HttpClient';
import { PageWrapper } from 'components/PageWrapper';

const TOPICS_API = '/api/v1/note_topics?category_id=';

@inject('clinicalNoteWritingTopicsStore')
@inject('alertStore')
@observer
class ClinicalNotesWritingTopicsList extends PureComponent {
  componentDidMount() {
    const {match, clinicalNoteWritingTopicsStore: {setTopics}} = this.props;
    const id = match.params.categoryId;

    if(id) {
      new HttpClient().get(`${TOPICS_API}${id}`).then(data => {
        const topics = data.body.data.note_topic;

        setTopics(topics);
      }).catch(() => {
        this.props.alertStore.success('Something went wrong');
      });
    }
  }

  componentWillUnmount() {
    const {clinicalNoteWritingTopicsStore: {setTopics}} = this.props;

    setTopics([]);
  }

  render() {
    const { clinicalNoteWritingTopicsStore: { topics } } = this.props;

    return (
      <PageWrapper>
        <div className="page-container">
          <h2>Topics</h2>
        </div>
        <div className="row">
          <div className="container">
            <div className="mcq-questions-list">
              {topics.length > 0 ? topics.map((topic) => (
                <a
                  key={`note_topic_${topic.id}`}
                  href={`https://finalmedexamprep.ie${topic.file_url}`}
                  target='_blank'
                  style={{
                    margin: '16px 0',
                    alignSelf: 'flex-start'
                  }}
                >
                  {topic.title}
                </a>
              )) : (
                <div className="empty-list-container">
                  <span className="self-center">There is no topics</span>
                </div>
              )}
            </div>
          </div>
        </div>
      </PageWrapper>
    );
  }
}

export default ClinicalNotesWritingTopicsList;



// WEBPACK FOOTER //
// ./src/modules/clinicalNoteWriting/containers/Topics.js